import keycloakAxios from '@/services/axios';
import {SportLocationForm} from '@/types/sportLocation';

export const addLocation = async (locationData: SportLocationForm) => {
  const response = await keycloakAxios.post(`admin/location`, locationData);

  if (response.status >= 300) {
    throw new Error(
      `Error adding location: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
